import axios from "axios";

export const getLocationDropdownLCA = ({ setDropdownData }) => {
  var config = {
    method: "get",
    url: "https://lca.aau.dk/api/locations/",
    headers: {
      Authorization: "Token 7a5a1d9f0926a74b538448307ad2c2be8a925cda",
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setDropdownData(
        response.data.results.map((size) => {
          size.label = size["name"];
          size.value = size["name"];
          return size;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};
